import React from 'react';
import { Route, Switch } from 'react-router-dom';
import EquipmentGroupList from './EquipmentGroupList';
import LoadHistoryPage from '../LoadHistory/LoadHistoryPage';
import { GanttChart } from '../gantt-chart';
import { EquipmentGroupKanban } from '../EquipmentGroupKanban';
import TripHistory from "../TripHistory/RoundTrip"

const EquipmentGroup = (props) => {
	const { match } = props;
	return <Switch>
		<Route exact path={`${match.path}/list`} component={EquipmentGroupList} />
		<Route exact path={`${match.path}/loadhistory/:egId/:crewId?/:isTruck?`} component={LoadHistoryPage} />
		<Route exact path={`${match.path}/ganttchart`} component={GanttChart} />
		<Route exact path={`${match.path}/kanban`} component={EquipmentGroupKanban} />
		<Route exact path={`${match.path}/trip/:egId`} component={TripHistory} />
	</Switch>;
}

export default EquipmentGroup;